import { request } from "../api";

// /api/accounting/payroll/*
export const getPayrollSettings = () => request.get("/payroll/settings");
export const updatePayrollSettings = body => request.put("/payroll/settings", body);
export const listBankAccounts = () => request.get("/payroll/bank-accounts");
export const listCostRates = () => request.get("/payroll/cost-rates");

export const employeesChecklist = () => request.get("/payroll/employees/checklist");
export const createSofortmeldung = employeeId =>
  request.post(`/payroll/employees/${employeeId}/sofortmeldung`);
export const listEmployeeDocuments = employeeId =>
  request.get(`/payroll/employees/${employeeId}/documents`);
export const createEmployeeDocument = (employeeId, kind, body) =>
  request.post(`/payroll/employees/${employeeId}/documents/${kind}`, body);
export const employeeDocumentBlob = (employeeId, docId) =>
  request.blob(`/payroll/employees/${employeeId}/documents/${docId}`);

export const listRuns = params => request.get("/payroll/runs", params);
export const createRun = period => request.post("/payroll/runs", period ? { period } : {});
export const getRun = id => request.get(`/payroll/runs/${id}`);
export const deleteRun = id => request.del(`/payroll/runs/${id}`);
export const calculateRun = id => request.post(`/payroll/runs/${id}/calculate`);
export const adjustSlip = (id, slipId, body) =>
  request.put(`/payroll/runs/${id}/slips/${slipId}`, body);
export const approveRun = id => request.post(`/payroll/runs/${id}/approve`);
export const createSepa = (id, body) => request.post(`/payroll/runs/${id}/sepa`, body);
export const sepaXmlBlob = id => request.blob(`/payroll/runs/${id}/sepa/xml`);
export const markPaid = id => request.post(`/payroll/runs/${id}/mark-paid`);
export const fileRun = id => request.post(`/payroll/runs/${id}/file`);

export const listFilings = params => request.get("/payroll/filings", params);
export const filingPayloadBlob = id => request.blob(`/payroll/filings/${id}/payload`);

export const lohnjournal = period => request.get("/payroll/journal", { period });
export const lohnkonto = (employeeId, year) =>
  request.get(`/payroll/lohnkonto/${employeeId}`, { year });
export const lohnkontoPdfBlob = (employeeId, year) =>
  request.blob(`/payroll/lohnkonto/${employeeId}/pdf`, { year });

export const createLohnsteuerbescheinigungen = year =>
  request.post(`/payroll/year/${year}/lohnsteuerbescheinigungen`);
export const createUvJahresmeldung = year => request.post(`/payroll/year/${year}/uv-jahresmeldung`);
